export const LOGOUT = 'LOGOUT'
export const SET_ERROR = 'SET_ERROR'
export const O365_REGISTER_REQUEST = 'O365_REGISTER_REQUEST'
export const O365_REGISTER_SUCCESS = 'O365_REGISTER_SUCCESS'
export const O365_REGISTER_FAILURE = 'O365_REGISTER_FAILURE'

export const O365_LOAD_EVENTS_REQUEST = 'O365_LOAD_EVENTS_REQUEST'
export const O365_LOAD_EVENTS_SUCCESS = 'O365_LOAD_EVENTS_SUCCESS'
export const O365_LOAD_EVENTS_FAILURE = 'O365_LOAD_EVENTS_FAILURE'

export const O365_LOAD_EVENT_REQUEST = 'O365_LOAD_EVENT_REQUEST'
export const O365_LOAD_EVENT_SUCCESS = 'O365_LOAD_EVENT_SUCCESS'
export const O365_LOAD_EVENT_FAILURE = 'O365_LOAD_EVENT_FAILURE'

export const O365_LOAD_EDIT_EVENT_REQUEST = 'O365_LOAD_EDIT_EVENT_REQUEST'
export const O365_LOAD_EDIT_EVENT_SUCCESS = 'O365_LOAD_EDIT_EVENT_SUCCESS'
export const O365_LOAD_EDIT_EVENT_FAILURE = 'O365_LOAD_EDIT_EVENT_FAILURE'

export const O365_LOAD_USER_INFO_REQUEST = 'O365_LOAD_USER_INFO_REQUEST'
export const O365_LOAD_USER_INFO_SUCCESS = 'O365_LOAD_USER_INFO_SUCCESS'
export const O365_LOAD_USER_INFO_FAILURE = 'O365_LOAD_USER_INFO_FAILURE'

export const O365_CREATE_EVENT_REQUEST = 'O365_CREATE_EVENT_REQUEST'
export const O365_CREATE_EVENT_SUCCESS = 'O365_CREATE_EVENT_SUCCESS'
export const O365_CREATE_EVENT_FAILURE = 'O365_CREATE_EVENT_FAILURE'

export const O365_UPDATE_EVENT_REQUEST = 'O365_UPDATE_EVENT_REQUEST'
export const O365_UPDATE_EVENT_SUCCESS = 'O365_UPDATE_EVENT_SUCCESS'
export const O365_UPDATE_EVENT_FAILURE = 'O365_UPDATE_EVENT_FAILURE'

export const O365_DELETE_EVENT_REQUEST = 'O365_DELETE_EVENT_REQUEST'
export const O365_DELETE_EVENT_SUCCESS = 'O365_DELETE_EVENT_SUCCESS'
export const O365_DELETE_EVENT_FAILURE = 'O365_DELETE_EVENT_FAILURE'

export const BSRS_LOGIN_REQUEST = 'BSRS_LOGIN_REQUEST'
export const BSRS_LOGIN_SUCCESS = 'BSRS_LOGIN_SUCCESS'
export const BSRS_LOGIN_FAILURE = 'BSRS_LOGIN_FAILURE'

export const PROFILE_LOGIN_REQUEST = 'PROFILE_LOGIN_REQUEST'
export const PROFILE_LOGIN_SUCCESS = 'PROFILE_LOGIN_SUCCESS'
export const PROFILE_LOGIN_FAILURE = 'PROFILE_LOGIN_FAILURE'

export const O365_ACCEPT_EVENT_REQUEST = 'O365_ACCEPT_EVENT_REQUEST'
export const O365_ACCEPT_EVENT_SUCCESS = 'O365_ACCEPT_EVENT_SUCCESS'
export const O365_ACCEPT_EVENT_FAILURE = 'O365_ACCEPT_EVENT_FAILURE'

export const O365_TENTATIVE_EVENT_REQUEST = 'O365_TENTATIVE_EVENT_REQUEST'
export const O365_TENTATIVE_EVENT_SUCCESS = 'O365_TENTATIVE_EVENT_SUCCESS'
export const O365_TENTATIVE_EVENT_FAILURE = 'O365_TENTATIVE_EVENT_FAILURE'

export const O365_DECLINE_EVENT_REQUEST = 'O365_DECLINE_EVENT_REQUEST'
export const O365_DECLINE_EVENT_SUCCESS = 'O365_DECLINE_EVENT_SUCCESS'
export const O365_DECLINE_EVENT_FAILURE = 'O365_DECLINE_EVENT_FAILURE'

export const CORE_LOAD_ORDERS_REQUEST = 'CORE_LOAD_ORDERS_REQUEST'
export const CORE_LOAD_ORDERS_SUCCESS = 'CORE_LOAD_ORDERS_SUCCESS'
export const CORE_LOAD_ORDERS_FAILURE = 'CORE_LOAD_ORDERS_FAILURE'

export const CORE_LOAD_ORDER_DETAIL_REQUEST = 'CORE_LOAD_ORDER_DETAIL_REQUEST'
export const CORE_LOAD_ORDER_DETAIL_SUCCESS = 'CORE_LOAD_ORDER_DETAIL_SUCCESS'
export const CORE_LOAD_ORDER_DETAIL_FAILURE = 'CORE_LOAD_ORDER_DETAIL_FAILURE'

export const CORE_CHANGE_ORDER_AMOUNT = 'CORE_CHANGE_ORDER_AMOUNT'

export const CORE_UPSERT_ORDERS_REQUEST = 'CORE_UPSERT_ORDERS_REQUEST'
export const CORE_UPSERT_ORDERS_SUCCESS = 'CORE_UPSERT_ORDERS_SUCCESS'
export const CORE_UPSERT_ORDERS_FAILURE = 'CORE_UPSERT_ORDERS_FAILURE'

export const CORE_LOAD_CHEKIN_REQUEST = 'CORE_LOAD_CHEKIN_REQUEST'
export const CORE_LOAD_CHEKIN_SUCCESS = 'CORE_LOAD_CHEKIN_SUCCESS'
export const CORE_LOAD_CHEKIN_FAILURE = 'CORE_LOAD_CHEKIN_FAILURE'

export const CORE_CREATE_CHECKIN_REQUEST = 'CORE_CREATE_CHECKIN_REQUEST'
export const CORE_CREATE_CHECKIN_SUCCESS = 'CORE_CREATE_CHECKIN_SUCCESS'
export const CORE_CREATE_CHECKIN_FAILURE = 'CORE_CREATE_CHECKIN_FAILURE'

export const O365_CHECKOUT_EVENT_REQUEST = 'O365_CHECKOUT_EVENT_REQUEST'
export const O365_CHECKOUT_EVENT_SUCCESS = 'O365_CHECKOUT_EVENT_SUCCESS'
export const O365_CHECKOUT_EVENT_FAILURE = 'O365_CHECKOUT_EVENT_FAILURE'

export const O365_LOAD_PEOPLE_REQUEST = 'O365_LOAD_PEOPLE_REQUEST'
export const O365_LOAD_PEOPLE_SUCCESS = 'O365_LOAD_PEOPLE_SUCCESS'
export const O365_LOAD_PEOPLE_FAILURE = 'O365_LOAD_PEOPLE_FAILURE'

export const O365_LOAD_LOCATION_REQUEST = 'O365_LOAD_LOCATION_REQUEST'
export const O365_LOAD_LOCATION_SUCCESS = 'O365_LOAD_LOCATION_SUCCESS'
export const O365_LOAD_LOCATION_FAILURE = 'O365_LOAD_LOCATION_FAILURE'

export const O365_SEARCH_SLOT_REQUEST = 'O365_SEARCH_SLOT_REQUEST'
export const O365_SEARCH_SLOT_SUCCESS = 'O365_SEARCH_SLOT_SUCCESS'
export const O365_SEARCH_SLOT_FAILURE = 'O365_SEARCH_SLOT_FAILURE'

export const CORE_INTEGRATION_O365_GO_ADD_CLIENT_ID = 'CORE_INTEGRATION_O365_GO_ADD_CLIENT_ID'
export const CORE_INTEGRATION_O365_GO_ADMIN_CONSENT = 'CORE_INTEGRATION_O365_GO_ADMIN_CONSENT'
export const CORE_INTEGRATION_O365_GO_SAVE_DATA = 'CORE_INTEGRATION_O365_GO_SAVE_DATA'

export const CORE_INTEGRATION_O365_ADD_CLIENT_ID = 'CORE_INTEGRATION_O365_ADD_CLIENT_ID'
export const CORE_INTEGRATION_O365_ADMIN_CONSENT = 'CORE_INTEGRATION_O365_ADMIN_CONSENT'
export const CORE_INTEGRATION_O365_REQUEST = 'CORE_INTEGRATION_O365_REQUEST'
export const CORE_INTEGRATION_O365_SUCCESS = 'CORE_INTEGRATION_O365_SUCCESS'
export const CORE_INTEGRATION_O365_FAILURE = 'CORE_INTEGRATION_O365_FAILURE'

export const CORE_LOAD_ROOM_REQUEST = 'CORE_LOAD_ROOM_REQUEST'
export const CORE_LOAD_ROOM_SUCCESS = ' CORE_LOAD_ROOM_SUCCESS'
export const CORE_LOAD_ROOM_FAILURE = ' CORE_LOAD_ROOM_FAILURE'

export const CORE_FIND_ROOM_REQUEST = 'CORE_FIND_ROOM_REQUEST'
export const CORE_FIND_ROOM_SUCCESS = ' CORE_FIND_ROOM_SUCCESS'
export const CORE_FIND_ROOM_FAILURE = ' CORE_FIND_ROOM_FAILURE'

export const CORE_UPDATE_ROOM_REQUEST = 'CORE_UPDATE_ROOM_REQUEST'
export const CORE_UPDATE_ROOM_SUCCESS = ' CORE_UPDATE_ROOM_SUCCESS'
export const CORE_UPDATE_ROOM_FAILURE = ' CORE_UPDATE_ROOM_FAILURE'

export const O365_LOAD_ROOM_REQUEST = 'O365_LOAD_ROOM_REQUEST'
export const O365_LOAD_ROOM_SUCCESS = 'O365_LOAD_ROOM_SUCCESS'
export const O365_LOAD_ROOM_FAILURE = 'O365_LOAD_ROOM_FAILURE'

export const O365_LOAD_ROOM_INFO_REQUEST = 'O365_LOAD_ROOM_INFO_REQUEST'
export const O365_LOAD_ROOM_INFO_SUCCESS = 'O365_LOAD_ROOM_INFO_SUCCESS'
export const O365_LOAD_ROOM_INFO_FAILURE = 'O365_LOAD_ROOM_INFO_FAILURE'

export const BSRS_SERVICE_TOKEN_REQUEST = 'BSRS_SERVICE_TOKEN_REQUEST'
export const BSRS_SERVICE_TOKEN_SUCCESS = 'BSRS_SERVICE_TOKEN_SUCCESS'
export const BSRS_SERVICE_TOKEN_FAILURE = 'BSRS_SERVICE_TOKEN_FAILURE'

export const CORE_LOAD_ALLROOM_REQUEST = 'CORE_LOAD_ALLROOM_REQUEST'
export const CORE_LOAD_ALLROOM_SUCCESS = 'CORE_LOAD_ALLROOM_SUCCESS'
export const CORE_LOAD_ALLROOM_FAILURE = 'CORE_LOAD_ALLROOM_FAILURE'

export const CORE_LOAD_REPORT_REQUEST = 'CORE_LOAD_REPORT_REQUEST'
export const CORE_LOAD_REPORT_SUCCESS = 'CORE_LOAD_REPORT_SUCCESS'
export const CORE_LOAD_REPORT_FAILURE = 'CORE_LOAD_REPORT_FAILURE'

export const CORE_LOAD_LOCATIONS_REPORT_REQUEST = 'CORE_LOAD_LOCATIONS_REPORT_REQUEST'
export const CORE_LOAD_LOCATIONS_REPORT_SUCCESS = 'CORE_LOAD_LOCATIONS_REPORT_SUCCESS'
export const CORE_LOAD_LOCATIONS_REPORT_FAILURE = 'CORE_LOAD_LOCATIONS_REPORT_FAILURE'

export const CORE_ADD_USER_REQUEST = 'CORE_ADD_USER_REQUEST'
export const CORE_ADD_USER_SUCCESS = 'CORE_ADD_USER_SUCCESS'
export const CORE_ADD_USER_FAILURE = 'CORE_ADD_USER_FAILURE'

export const CORE_LOAD_USERS_REQUEST = 'CORE_LOAD_USERS_REQUEST'
export const CORE_LOAD_USERS_SUCCESS = 'CORE_LOAD_USERS_SUCCESS'
export const CORE_LOAD_USERS_FAILURE = 'CORE_LOAD_USERS_FAILURE'

export const CORE_LOAD_USER_REQUEST = 'CORE_LOAD_USER_REQUEST'
export const CORE_LOAD_USER_SUCCESS = 'CORE_LOAD_USER_SUCCESS'
export const CORE_LOAD_USER_FAILURE = 'CORE_LOAD_USER_FAILURE'

export const CORE_UPDATE_USER_REQUEST = 'CORE_UPDATE_USER_REQUEST'
export const CORE_UPDATE_USER_SUCCESS = 'CORE_UPDATE_USER_SUCCESS'
export const CORE_UPDATE_USER_FAILURE = 'CORE_UPDATE_USER_FAILURE'

export const CORE_DELETE_USER_REQUEST = 'CORE_DELETE_USER_REQUEST'
export const CORE_DELETE_USER_SUCCESS = 'CORE_DELETE_USER_SUCCESS'
export const CORE_DELETE_USER_FAILURE = 'CORE_DELETE_USER_FAILURE'

export const CORE_USER_CHANGEPASS_REQUEST = 'CORE_USER_CHANGEPASS_REQUEST'
export const CORE_USER_CHANGEPASS_SUCCESS = 'CORE_USER_CHANGEPASS_SUCCESS'
export const CORE_USER_CHANGEPASS_FAILURE = 'CORE_USER_CHANGEPASS_FAILURE'

export const CORE_EDIT_USER_REQUEST = 'CORE_EDIT_USER_REQUEST'
export const CORE_EDIT_USER_SUCCESS = 'CORE_EDIT_USER_SUCCESS'
export const CORE_EDIT_USER_FAILURE = 'CORE_EDIT_USER_FAILURE'

export const CORE_CREATE_SYNC_REQUEST = 'CORE_CREATE_SYNC_REQUEST'
export const CORE_CREATE_SYNC_SUCCESS = 'CORE_CREATE_SYNC_SUCCESS'
export const CORE_CREATE_SYNC_FAILURE = 'CORE_CREATE_SYNC_FAILURE'

export const CORE_CREATE_USER_REQUEST = 'CORE_CREATE_USER_REQUEST'
export const CORE_CREATE_USER_SUCCESS = 'CORE_CREATE_USER_SUCCESS'
export const CORE_CREATE_USER_FAILURE = 'CORE_CREATE_USER_FAILURE'

export const CORE_EDIT_SYNC_REQUEST = 'CORE_EDIT_SYNC_REQUEST'
export const CORE_EDIT_SYNC_SUCCESS = 'CORE_EDIT_SYNC_SUCCESS'
export const CORE_EDIT_SYNC_FAILURE = 'CORE_EDIT_SYNC_FAILURE'

export const CORE_LOAD_SYNC_USER_REQUEST = 'CORE_LOAD_SYNC_USER_REQUEST'
export const CORE_LOAD_SYNC_USER_SUCCESS = 'CORE_LOAD_SYNC_USER_SUCCESS'
export const CORE_LOAD_SYNC_USER_FAILURE = 'CORE_LOAD_SYNC_USER_FAILURE'

export const CORE_LOAD_SYSTEM_REQUEST = 'CORE_LOAD_SYSTEM_REQUEST'
export const CORE_LOAD_SYSTEM_SUCCESS = 'CORE_LOAD_SYSTEM_SUCCESS'
export const CORE_LOAD_SYSTEM_FAILURE = 'CORE_LOAD_SYSTEM_FAILURE'

export const CORE_LOAD_LOCAL_USERS_REQUEST = 'CORE_LOAD_LOCAL_USERS_REQUEST'
export const CORE_LOAD_LOCAL_USERS_SUCCESS = 'CORE_LOAD_LOCAL_USERS_SUCCESS'
export const CORE_LOAD_LOCAL_USERS_FAILURE = 'CORE_LOAD_LOCAL_USERS_FAILURE'

export const CORE_DELETE_LOCAL_USERS_REQUEST = 'CORE_DELETE_LOCAL_USERS_REQUEST'
export const CORE_DELETE_LOCAL_USERS_SUCCESS = 'CORE_DELETE_LOCAL_USERS_SUCCESS'
export const CORE_DELETE_LOCAL_USERS_FAILURE = 'CORE_DELETE_LOCAL_USERS_FAILURE'

export const CORE_LOAD_ALL_FLOOR_REQUEST = 'CORE_LOAD_ALL_FLOOR_REQUEST'
export const CORE_LOAD_ALL_FLOOR_SUCCESS = 'CORE_LOAD_ALL_FLOOR_SUCCESS'
export const CORE_LOAD_ALL_FLOOR_FAILURE = 'CORE_LOAD_ALL_FLOOR_FAILURE'

export const CORE_LOAD_ALL_AMENITIES_REQUEST = 'CORE_LOAD_ALL_AMENITIES_REQUEST'
export const CORE_LOAD_ALL_AMENITIES_SUCCESS = 'CORE_LOAD_ALL_AMENITIES_SUCCESS'
export const CORE_LOAD_ALL_AMENITIES_FAILURE = 'CORE_LOAD_ALL_AMENITIES_FAILURE'

export const CORE_CREATE_ROOM_REQUEST = 'CORE_CREATE_ROOM_REQUEST'
export const CORE_CREATE_ROOM_SUCCESS = 'CORE_CREATE_ROOM_SUCCESS'
export const CORE_CREATE_ROOM_FAILURE = 'CORE_CREATE_ROOM_FAILURE'

export const CORE_EDIT_ROOM_REQUEST = 'CORE_EDIT_ROOM_REQUEST'
export const CORE_EDIT_ROOM_SUCCESS = 'CORE_EDIT_ROOM_SUCCESS'
export const CORE_EDIT_ROOM_FAILURE = 'CORE_EDIT_ROOM_FAILURE'

export const CORE_CREATE_DISABLE_ROOM_REQUEST = 'CORE_CREATE_DISABLE_ROOM_REQUEST'
export const CORE_CREATE_DISABLE_ROOM_SUCCESS = 'CORE_CREATE_DISABLE_ROOM_SUCCESS'
export const CORE_CREATE_DISABLE_ROOM_FAILURE = 'CORE_CREATE_DISABLE_ROOM_FAILURE'

export const CORE_EDIT_DISABLE_ROOM_REQUEST = 'CORE_EDIT_DISABLE_ROOM_REQUEST'
export const CORE_EDIT_DISABLE_ROOM_SUCCESS = 'CORE_EDIT_DISABLE_ROOM_SUCCESS'
export const CORE_EDIT_DISABLE_ROOM_FAILURE = 'CORE_EDIT_DISABLE_ROOM_FAILURE'

export const CORE_DELETE_DISABLE_ROOM_REQUEST = 'CORE_DELETE_DISABLE_ROOM_REQUEST'
export const CORE_DELETE_DISABLE_ROOM_SUCCESS = 'CORE_DELETE_DISABLE_ROOM_SUCCESS'
export const CORE_DELETE_DISABLE_ROOM_FAILURE = 'CORE_DELETE_DISABLE_ROOM_FAILURE'

export const CORE_LOAD_ROOMS_REQUEST = 'CORE_LOAD_ROOMS_REQUEST'
export const CORE_LOAD_ROOMS_SUCCESS = 'CORE_LOAD_ROOMS_SUCCESS'
export const CORE_LOAD_ROOMS_FAILURE = 'CORE_LOAD_ROOMS_FAILURE'

export const CORE_DELETE_ROOM_REQUEST = 'CORE_DELETE_ROOM_REQUEST'
export const CORE_DELETE_ROOM_SUCCESS = 'CORE_DELETE_ROOM_SUCCESS'
export const CORE_DELETE_ROOM_FAILURE = 'CORE_DELETE_ROOM_FAILURE'

export const CORE_LOAD_QRCODE_REQUEST = 'CORE_LOAD_QRCODE_REQUEST'
export const CORE_LOAD_QRCODE_SUCCESS = 'CORE_LOAD_QRCODE_SUCCESS'
export const CORE_LOAD_QRCODE_FAILURE = 'CORE_LOAD_QRCODE_FAILURE'

export const CORE_CHANGE_QRCODE_REQUEST = 'CORE_CHANGE_QRCODE_REQUEST'
export const CORE_CHANGE_QRCODE_SUCCESS = 'CORE_CHANGE_QRCODE_SUCCESS'
export const CORE_CHANGE_QRCODE_FAILURE = 'CORE_CHANGE_QRCODE_FAILURE'

export const CORE_CHANGE_PASSWORD_REQUEST = 'CORE_CHANGE_PASSWORD_REQUEST'
export const CORE_CHANGE_PASSWORD_SUCCESS = 'CORE_CHANGE_PASSWORD_SUCCESS'
export const CORE_CHANGE_PASSWORD_FAILURE = 'CORE_CHANGE_PASSWORD_FAILURE'

export const CORE_RESET_PASSWORD_REQUEST = 'CORE_RESET_PASSWORD_REQUEST'
export const CORE_RESET_PASSWORD_SUCCESS = 'CORE_RESET_PASSWORD_SUCCESS'
export const CORE_RESET_PASSWORD_FAILURE = 'CORE_RESET_PASSWORD_FAILURE'

export const CORE_CREATE_FBS_REQUEST = 'CORE_CREATE_FBS_REQUEST'
export const CORE_CREATE_FBS_SUCCESS = 'CORE_CREATE_FBS_SUCCESS'
export const CORE_CREATE_FBS_FAILURE = 'CORE_CREATE_FBS_FAILURE'

export const CORE_EDIT_FBS_REQUEST = 'CORE_EDIT_FBS_REQUEST'
export const CORE_EDIT_FBS_SUCCESS = 'CORE_EDIT_FBS_SUCCESS'
export const CORE_EDIT_FBS_FAILURE = 'CORE_EDIT_FBS_FAILURE'

export const CORE_DELETE_FBS_REQUEST = 'CORE_DELETE_FBS_REQUEST'
export const CORE_DELETE_FBS_SUCCESS = 'CORE_DELETE_FBS_SUCCESS'
export const CORE_DELETE_FBS_FAILURE = 'CORE_DELETE_FBS_FAILURE'

export const CORE_LOAD_ALL_FBS_REQUEST = 'CORE_LOAD_ALL_FBS_REQUEST'
export const CORE_LOAD_ALL_FBS_SUCCESS = 'CORE_LOAD_ALL_FBS_SUCCESS'
export const CORE_LOAD_ALL_FBS_FAILURE = 'CORE_LOAD_ALL_FBS_FAILURE'

export const CORE_LOAD_FBS_REQUEST = 'CORE_LOAD_FBS_REQUEST'
export const CORE_LOAD_FBS_SUCCESS = 'CORE_LOAD_FBS_SUCCESS'
export const CORE_LOAD_FBS_FAILURE = 'CORE_LOAD_FBS_FAILURE'

export const CORE_LOAD_ALL_BUILDINGS_REQUEST = 'CORE_LOAD_ALL_BUILDINGS_REQUEST'
export const CORE_LOAD_ALL_BUILDINGS_SUCCESS = 'CORE_LOAD_ALL_BUILDINGS_SUCCESS'
export const CORE_LOAD_ALL_BUILDINGS_FAILURE = 'CORE_LOAD_ALL_BUILDINGS_FAILURE'

export const CORE_LOAD_BUILDING_REQUEST = 'CORE_LOAD_BUILDING_REQUEST'
export const CORE_LOAD_BUILDING_SUCCESS = 'CORE_LOAD_BUILDING_SUCCESS'
export const CORE_LOAD_BUILDING_FAILURE = 'CORE_LOAD_BUILDING_FAILURE'

export const CORE_CREATE_BUILDING_REQUEST = 'CORE_CREATE_BUILDING_REQUEST'
export const CORE_CREATE_BUILDING_SUCCESS = 'CORE_CREATE_BUILDING_SUCCESS'
export const CORE_CREATE_BUILDING_FAILURE = 'CORE_CREATE_BUILDING_FAILURE'

export const CORE_EDIT_BUILDING_REQUEST = 'CORE_EDIT_BUILDING_REQUEST'
export const CORE_EDIT_BUILDING_SUCCESS = 'CORE_EDIT_BUILDING_SUCCESS'
export const CORE_EDIT_BUILDING_FAILURE = 'CORE_EDIT_BUILDING_FAILURE'

export const CORE_DELETE_BUILDING_REQUEST = 'CORE_DELETE_BUILDING_REQUEST'
export const CORE_DELETE_BUILDING_SUCCESS = 'CORE_DELETE_BUILDING_SUCCESS'
export const CORE_DELETE_BUILDING_FAILURE = 'CORE_DELETE_BUILDING_FAILURE'

export const CORE_LOAD_ALL_FBS_CATEGORY_REQUEST = 'CORE_LOAD_ALL_FBS_CATEGORY_REQUEST'
export const CORE_LOAD_ALL_FBS_CATEGORY_SUCCESS = 'CORE_LOAD_ALL_FBS_CATEGORY_SUCCESS'
export const CORE_LOAD_ALL_FBS_CATEGORY_FAILURE = 'CORE_LOAD_ALL_FBS_CATEGORY_FAILURE'

export const CORE_CREATE_FLOOR_REQUEST = 'CORE_CREATE_FLOOR_REQUEST'
export const CORE_CREATE_FLOOR_SUCCESS = 'CORE_CREATE_FLOOR_SUCCESS'
export const CORE_CREATE_FLOOR_FAILURE = 'CORE_CREATE_FLOOR_FAILURE'

export const CORE_EDIT_FLOOR_REQUEST = 'CORE_EDIT_FLOOR_REQUEST'
export const CORE_EDIT_FLOOR_SUCCESS = 'CORE_EDIT_FLOOR_SUCCESS'
export const CORE_EDIT_FLOOR_FAILURE = 'CORE_EDIT_FLOOR_FAILURE'

export const CORE_LOAD_FLOOR_REQUEST = 'CORE_LOAD_FLOOR_REQUEST'
export const CORE_LOAD_FLOOR_SUCCESS = 'CORE_LOAD_FLOOR_SUCCESS'
export const CORE_LOAD_FLOOR_FAILURE = 'CORE_LOAD_FLOOR_FAILURE'

export const CORE_DELETE_FLOOR_REQUEST = 'CORE_DELETE_FLOOR_REQUEST'
export const CORE_DELETE_FLOOR_SUCCESS = 'CORE_DELETE_FLOOR_SUCCESS'
export const CORE_DELETE_FLOOR_FAILURE = 'CORE_DELETE_FLOOR_FAILURE'

export const CORE_LOAD_ALL_HOLIDAYS_REQUEST = 'CORE_LOAD_ALL_HOLIDAYS_REQUEST'
export const CORE_LOAD_ALL_HOLIDAYS_SUCCESS = 'CORE_LOAD_ALL_HOLIDAYS_SUCCESS'
export const CORE_LOAD_ALL_HOLIDAYS_FAILURE = 'CORE_LOAD_ALL_HOLIDAYS_FAILURE'

export const CORE_LOAD_HOLIDAY_REQUEST = 'CORE_LOAD_HOLIDAY_REQUEST'
export const CORE_LOAD_HOLIDAY_SUCCESS = 'CORE_LOAD_HOLIDAY_SUCCESS'
export const CORE_LOAD_HOLIDAY_FAILURE = 'CORE_LOAD_HOLIDAY_FAILURE'

export const CORE_CREATE_HOLIDAY_REQUEST = 'CORE_CREATE_HOLIDAY_REQUEST'
export const CORE_CREATE_HOLIDAY_SUCCESS = 'CORE_CREATE_HOLIDAY_SUCCESS'
export const CORE_CREATE_HOLIDAY_FAILURE = 'CORE_CREATE_HOLIDAY_FAILURE'

export const CORE_EDIT_HOLIDAY_REQUEST = 'CORE_EDIT_HOLIDAY_REQUEST'
export const CORE_EDIT_HOLIDAY_SUCCESS = 'CORE_EDIT_HOLIDAY_SUCCESS'
export const CORE_EDIT_HOLIDAY_FAILURE = 'CORE_EDIT_HOLIDAY_FAILURE'

export const CORE_DELETE_HOLIDAY_REQUEST = 'CORE_DELETE_HOLIDAY_REQUEST'
export const CORE_DELETE_HOLIDAY_SUCCESS = 'CORE_DELETE_HOLIDAY_SUCCESS'
export const CORE_DELETE_HOLIDAY_FAILURE = 'CORE_DELETE_HOLIDAY_FAILURE'
export const CORE_LOAD_DISABLE_ROOMS_REQUEST = 'CORE_LOAD_DISABLE_ROOMS_REQUEST'
export const CORE_LOAD_DISABLE_ROOMS_SUCCESS = 'CORE_LOAD_DISABLE_ROOMS_SUCCESS'
export const CORE_LOAD_DISABLE_ROOMS_FAILURE = 'CORE_LOAD_DISABLE_ROOMS_FAILURE'

export const CORE_LOAD_DISABLE_ROOM_REQUEST = 'CORE_LOAD_DISABLE_ROOM_REQUEST'
export const CORE_LOAD_DISABLE_ROOM_SUCCESS = 'CORE_LOAD_DISABLE_ROOM_SUCCESS'
export const CORE_LOAD_DISABLE_ROOM_FAILURE = 'CORE_LOAD_DISABLE_ROOM_FAILURE'

export const CORE_CREATE_AMENITY_REQUEST = 'CORE_CREATE_AMENITY_REQUEST'
export const CORE_CREATE_AMENITY_SUCCESS = 'CORE_CREATE_AMENITY_SUCCESS'
export const CORE_CREATE_AMENITY_FAILURE = 'CORE_CREATE_AMENITY_FAILURE'

export const CORE_EDIT_AMENITY_REQUEST = 'CORE_EDIT_AMENITY_REQUEST'
export const CORE_EDIT_AMENITY_SUCCESS = 'CORE_EDIT_AMENITY_SUCCESS'
export const CORE_EDIT_AMENITY_FAILURE = 'CORE_EDIT_AMENITY_FAILURE'

export const CORE_LOAD_ALL_AMENITY_REQUEST = 'CORE_LOAD_ALL_AMENITY_REQUEST'
export const CORE_LOAD_ALL_AMENITY_SUCCESS = 'CORE_LOAD_ALL_AMENITY_SUCCESS'
export const CORE_LOAD_ALL_AMENITY_FAILURE = 'CORE_LOAD_ALL_AMENITY_FAILURE'

export const CORE_LOAD_AMENITY_REQUEST = 'CORE_LOAD_AMENITY_REQUEST'
export const CORE_LOAD_AMENITY_SUCCESS = 'CORE_LOAD_AMENITY_SUCCESS'
export const CORE_LOAD_AMENITY_FAILURE = 'CORE_LOAD_AMENITY_FAILURE'

export const CORE_DELETE_AMENITY_REQUEST = 'CORE_DELETE_AMENITY_REQUEST'
export const CORE_DELETE_AMENITY_SUCCESS = 'CORE_DELETE_AMENITY_SUCCESS'
export const CORE_DELETE_AMENITY_FAILURE = 'CORE_DELETE_AMENITY_FAILURE'

export const CORE_LOAD_SETTING_REQUEST = 'CORE_LOAD_SETTING_REQUEST'
export const CORE_LOAD_SETTING_SUCCESS = 'CORE_LOAD_SETTING_SUCCESS'
export const CORE_LOAD_SETTING_FAILURE = 'CORE_LOAD_SETTING_FAILURE'

export const CORE_UPDATE_SETTING_REQUEST = 'CORE_UPDATE_SETTING_REQUEST'
export const CORE_UPDATE_SETTING_SUCCESS = 'CORE_UPDATE_SETTING_SUCCESS'
export const CORE_UPDATE_SETTING_FAILURE = 'CORE_UPDATE_SETTING_FAILURE'

export const CORE_CREATE_TITLE_REQUEST = 'CORE_CREATE_TITLE_REQUEST'
export const CORE_CREATE_TITLE_SUCCESS = 'CORE_CREATE_TITLE_SUCCESS'
export const CORE_CREATE_TITLE_FAILURE = 'CORE_CREATE_TITLE_FAILURE'

export const CORE_EDIT_TITLE_REQUEST = 'CORE_EDIT_TITLE_REQUEST'
export const CORE_EDIT_TITLE_SUCCESS = 'CORE_EDIT_TITLE_SUCCESS'
export const CORE_EDIT_TITLE_FAILURE = 'CORE_EDIT_TITLE_FAILURE'

export const CORE_LOAD_ALL_TITLE_REQUEST = 'CORE_LOAD_ALL_TITLE_REQUEST'
export const CORE_LOAD_ALL_TITLE_SUCCESS = 'CORE_LOAD_ALL_TITLE_SUCCESS'
export const CORE_LOAD_ALL_TITLE_FAILURE = 'CORE_LOAD_ALL_TITLE_FAILURE'

export const CORE_LOAD_TITLE_REQUEST = 'CORE_LOAD_TITLE_REQUEST'
export const CORE_LOAD_TITLE_SUCCESS = 'CORE_LOAD_TITLE_SUCCESS'
export const CORE_LOAD_TITLE_FAILURE = 'CORE_LOAD_TITLE_FAILURE'

export const CORE_DELETE_TITLE_REQUEST = 'CORE_DELETE_TITLE_REQUEST'
export const CORE_DELETE_TITLE_SUCCESS = 'CORE_DELETE_TITLE_SUCCESS'
export const CORE_DELETE_TITLE_FAILURE = 'CORE_DELETE_TITLE_FAILURE'

export const CORE_LOAD_EXECUTIVE_ROOM_REQUEST = 'CORE_LOAD_EXECUTIVE_ROOM_REQUEST'
export const CORE_LOAD_EXECUTIVE_ROOM_SUCCESS = 'CORE_LOAD_EXECUTIVE_ROOM_SUCCESS'
export const CORE_LOAD_EXECUTIVE_ROOM_FAILURE = 'CORE_LOAD_EXECUTIVE_ROOM_FAILURE'

export const CORE_LOAD_EVENTREPORT_REQUEST = 'CORE_LOAD_EVENTREPORT_REQUEST'
export const CORE_LOAD_EVENTREPORT_SUCCESS = 'CORE_LOAD_EVENTREPORT_SUCCESS'
export const CORE_LOAD_EVENTREPORT_FAILURE = 'CORE_LOAD_EVENTREPORT_FAILURE'

export const CORE_LOAD_ALL_ROOMFORMATS_REQUEST = 'CORE_LOAD_ALL_ROOMFORMATS_REQUEST'
export const CORE_LOAD_ALL_ROOMFORMATS_SUCCESS = 'CORE_LOAD_ALL_ROOMFORMATS_SUCCESS'
export const CORE_LOAD_ALL_ROOMFORMATS_FAILURE = 'CORE_LOAD_ALL_ROOMFORMATS_FAILURE'

export const CORE_CREATE_ROOMFORMAT_REQUEST = 'CORE_CREATE_ROOMFORMAT_REQUEST'
export const CORE_CREATE_ROOMFORMAT_SUCCESS = 'CORE_CREATE_ROOMFORMAT_SUCCESS'
export const CORE_CREATE_ROOMFORMAT_FAILURE = 'CORE_CREATE_ROOMFORMAT_FAILURE'

export const CORE_LOAD_ROOMFORMAT_REQUEST = 'CORE_LOAD_ROOMFORMAT_REQUEST'
export const CORE_LOAD_ROOMFORMAT_SUCCESS = 'CORE_LOAD_ROOMFORMAT_SUCCESS'
export const CORE_LOAD_ROOMFORMAT_FAILURE = 'CORE_LOAD_ROOMFORMAT_FAILURE'

export const CORE_EDIT_ROOMFORMAT_REQUEST = 'CORE_EDIT_ROOMFORMAT_REQUEST'
export const CORE_EDIT_ROOMFORMAT_SUCCESS = 'CORE_EDIT_ROOMFORMAT_SUCCESS'
export const CORE_EDIT_ROOMFORMAT_FAILURE = 'CORE_EDIT_ROOMFORMAT_FAILURE'

export const CORE_DELETE_ROOMFORMAT_REQUEST = 'CORE_DELETE_ROOMFORMAT_REQUEST'
export const CORE_DELETE_ROOMFORMAT_SUCCESS = 'CORE_DELETE_ROOMFORMAT_SUCCESS'
export const CORE_DELETE_ROOMFORMAT_FAILURE = 'CORE_DELETE_ROOMFORMAT_FAILURE'

export const CORE_LOAD_ALL_ROOMTYPE_REQUEST = 'CORE_LOAD_ALL_ROOMTYPE_REQUEST'
export const CORE_LOAD_ALL_ROOMTYPE_SUCCESS = 'CORE_LOAD_ALL_ROOMTYPE_SUCCESS'
export const CORE_LOAD_ALL_ROOMTYPE_FAILURE = 'CORE_LOAD_ALL_ROOMTYPE_FAILURE'

export const CORE_LOAD_USERFILTER_REQUEST = 'CORE_LOAD_USERFILTER_REQUEST'
export const CORE_LOAD_USERFILTER_SUCCESS = 'CORE_LOAD_USERFILTER_SUCCESS'
export const CORE_LOAD_USERFILTER_FAILURE = 'CORE_LOAD_USERFILTER_FAILURE'

export const CORE_CANCEL_EVENT_REQUEST = 'CORE_CANCEL_EVENT_REQUEST'
export const CORE_CANCEL_EVENT_SUCCESS = 'CORE_CANCEL_EVENT_SUCCESS'
export const CORE_CANCEL_EVENT_FAILURE = 'CORE_CANCEL_EVENT_FAILURE'

export const CORE_FILTER_AMENITY_REQUEST = 'CORE_FILTER_AMENITY_REQUEST'
export const CORE_FILTER_AMENITY_SUCCESS = 'CORE_FILTER_AMENITY_SUCCESS'
export const CORE_FILTER_AMENITY_FAILURE = 'CORE_FILTER_AMENITY_FAILURE'

export const CORE_DOWN_SEQ_FBS_REQUEST = 'CORE_DOWN_SEQ_FBS_REQUEST'
export const CORE_DOWN_SEQ_FBS_SUCCESS = 'CORE_DOWN_SEQ_FBS_SUCCESS'
export const CORE_DOWN_SEQ_FBS_FAILURE = 'CORE_DOWN_SEQ_FBS_FAILURE'

export const CORE_UP_SEQ_FBS_REQUEST = 'CORE_UP_SEQ_FBS_REQUEST'
export const CORE_UP_SEQ_FBS_SUCCESS = 'CORE_UP_SEQ_FBS_SUCCESS'
export const CORE_UP_SEQ_FBS_FAILURE = 'CORE_UP_SEQ_FBS_FAILURE'

export const CORE_DOWN_SEQ_AMENITY_REQUEST = 'CORE_DOWN_SEQ_AMENITY_REQUEST'
export const CORE_DOWN_SEQ_AMENITY_SUCCESS = 'CORE_DOWN_SEQ_AMENITY_SUCCESS'
export const CORE_DOWN_SEQ_AMENITY_FAILURE = 'CORE_DOWN_SEQ_AMENITY_FAILURE'

export const CORE_UP_SEQ_AMENITY_REQUEST = 'CORE_UP_SEQ_AMENITY_REQUEST'
export const CORE_UP_SEQ_AMENITY_SUCCESS = 'CORE_UP_SEQ_AMENITY_SUCCESS'
export const CORE_UP_SEQ_AMENITY_FAILURE = 'CORE_UP_SEQ_AMENITY_FAILURE'

export const CORE_DOWN_SEQ_TITLE_REQUEST = 'CORE_DOWN_SEQ_TITLE_REQUEST'
export const CORE_DOWN_SEQ_TITLE_SUCCESS = 'CORE_DOWN_SEQ_TITLE_SUCCESS'
export const CORE_DOWN_SEQ_TITLE_FAILURE = 'CORE_DOWN_SEQ_TITLE_FAILURE'

export const CORE_UP_SEQ_TITLE_REQUEST = 'CORE_UP_SEQ_TITLE_REQUEST'
export const CORE_UP_SEQ_TITLE_SUCCESS = 'CORE_UP_SEQ_TITLE_SUCCESS'
export const CORE_UP_SEQ_TITLE_FAILURE = 'CORE_UP_SEQ_TITLE_FAILURE'

export const CORE_FILTER_ROOM_REQUEST = 'CORE_FILTER_ROOM_REQUEST'
export const CORE_FILTER_ROOM_SUCCESS = 'CORE_FILTER_ROOM_SUCCESS'
export const CORE_FILTER_ROOM_FAILURE = 'CORE_FILTER_ROOM_FAILURE'

export const CORE_FILTER_ROOMFORMAT_REQUEST = 'CORE_FILTER_ROOMFORMAT_REQUEST'
export const CORE_FILTER_ROOMFORMAT_SUCCESS = 'CORE_FILTER_ROOMFORMAT_SUCCESS'
export const CORE_FILTER_ROOMFORMAT_FAILURE = 'CORE_FILTER_ROOMFORMAT_FAILURE'

export const CORE_FILTER_FLOOR_REQUEST = 'CORE_FILTER_FLOOR_REQUEST'
export const CORE_FILTER_FLOOR_SUCCESS = 'CORE_FILTER_FLOOR_SUCCESS'
export const CORE_FILTER_FLOOR_FAILURE = 'CORE_FILTER_FLOOR_FAILURE'

export const CORE_FILTER_FBS_REQUEST = 'CORE_FILTER_FBS_REQUEST'
export const CORE_FILTER_FBS_SUCCESS = 'CORE_FILTER_FBS_SUCCESS'
export const CORE_FILTER_FBS_FAILURE = 'CORE_FILTER_FBS_FAILURE'

export const CORE_FILTER_BUILDING_REQUEST = 'CORE_FILTER_BUILDING_REQUEST'
export const CORE_FILTER_BUILDING_SUCCESS = 'CORE_FILTER_BUILDING_SUCCESS'
export const CORE_FILTER_BUILDING_FAILURE = 'CORE_FILTER_BUILDING_FAILURE'

export const CORE_LOAD_ADMINREPORT_REQUEST = 'CORE_LOAD_ADMINREPORT_REQUEST'
export const CORE_LOAD_ADMINREPORT_SUCCESS = 'CORE_LOAD_ADMINREPORT_SUCCESS'
export const CORE_LOAD_ADMINREPORT_FAILURE = 'CORE_LOAD_ADMINREPORT_FAILURE'

export const CORE_SEARCH_EVENTS_REQUEST = 'CORE_SEARCH_EVENTS_REQUEST'
export const CORE_SEARCH_EVENTS_SUCCESS = 'CORE_SEARCH_EVENTS_SUCCESS'
export const CORE_SEARCH_EVENTS_FAILURE = 'CORE_SEARCH_EVENTS_FAILURE'

export const CORE_LOAD_PRIVATE_ROOM_REQUEST = 'CORE_LOAD_PRIVATE_ROOM_REQUEST'
export const CORE_LOAD_PRIVATE_ROOM_SUCCESS = 'CORE_LOAD_PRIVATE_ROOM_SUCCESS'
export const CORE_LOAD_PRIVATE_ROOM_FAILURE = 'CORE_LOAD_PRIVATE_ROOM_FAILURE'

export const CORE_LOAD_ROOM_GROUP_BY_TYPE_REQUEST = 'CORE_LOAD_ROOM_GROUP_BY_TYPE_REQUEST'
export const CORE_LOAD_ROOM_GROUP_BY_TYPE_SUCCESS = 'CORE_LOAD_ROOM_GROUP_BY_TYPE_SUCCESS'
export const CORE_LOAD_ROOM_GROUP_BY_TYPE_FAILURE = 'CORE_LOAD_ROOM_GROUP_BY_TYPE_FAILURE'

export const CORE_REOPEN_EVENT_REQUEST = 'CORE_REOPEN_EVENT_REQUEST'
export const CORE_REOPEN_EVENT_SUCCESS = 'CORE_REOPEN_EVENT_SUCCESS'
export const CORE_REOPEN_EVENT_FAILURE = 'CORE_REOPEN_EVENT_FAILURE'

export const CORE_REQUEST_CHANGE_PASSWORD_REQUEST = 'CORE_REQUEST_CHANGE_PASSWORD_REQUEST'
export const CORE_REQUEST_CHANGE_PASSWORD_SUCCESS = 'CORE_REQUEST_CHANGE_PASSWORD_SUCCESS'
export const CORE_REQUEST_CHANGE_PASSWORD_FAILURE = 'CORE_REQUEST_CHANGE_PASSWORD_FAILURE'

export const CORE_IMPORT_USER_FILE_REQUEST = 'CORE_IMPORT_USER_FILE_REQUEST'
export const CORE_IMPORT_USER_FILE_SUCCESS = 'CORE_IMPORT_USER_FILE_SUCCESS'
export const CORE_IMPORT_USER_FILE_FAILURE = 'CORE_IMPORT_USER_FILE_FAILURE'

export const CORE_SEND_EMAIL_REQ_RESET_PASSWORD_REQUEST = 'CORE_SEND_EMAIL_REQ_RESET_PASSWORD_REQUEST'
export const CORE_SEND_EMAIL_REQ_RESET_PASSWORD_SUCCESS = 'CORE_SEND_EMAIL_REQ_RESET_PASSWORD_SUCCESS'
export const CORE_SEND_EMAIL_REQ_RESET_PASSWORD_FAILURE = 'CORE_SEND_EMAIL_REQ_RESET_PASSWORD_FAILURE'

export const CORE_CREATE_ROLE_REQUEST = 'CORE_CREATE_ROLE_REQUEST'
export const CORE_CREATE_ROLE_SUCCESS = 'CORE_CREATE_ROLE_SUCCESS'
export const CORE_CREATE_ROLE_FAILURE = 'CORE_CREATE_ROLE_FAILURE'

export const CORE_EDIT_ROLE_REQUEST = 'CORE_EDIT_ROLE_REQUEST'
export const CORE_EDIT_ROLE_SUCCESS = 'CORE_EDIT_ROLE_SUCCESS'
export const CORE_EDIT_ROLE_FAILURE = 'CORE_EDIT_ROLE_FAILURE'

export const CORE_LOAD_ALL_ROLE_REQUEST = 'CORE_LOAD_ALL_ROLE_REQUEST'
export const CORE_LOAD_ALL_ROLE_SUCCESS = 'CORE_LOAD_ALL_ROLE_SUCCESS'
export const CORE_LOAD_ALL_ROLE_FAILURE = 'CORE_LOAD_ALL_ROLE_FAILURE'

export const CORE_LOAD_ROLE_REQUEST = 'CORE_LOAD_ROLE_REQUEST'
export const CORE_LOAD_ROLE_SUCCESS = 'CORE_LOAD_ROLE_SUCCESS'
export const CORE_LOAD_ROLE_FAILURE = 'CORE_LOAD_ROLE_FAILURE'

export const CORE_DELETE_ROLE_REQUEST = 'CORE_DELETE_ROLE_REQUEST'
export const CORE_DELETE_ROLE_SUCCESS = 'CORE_DELETE_ROLE_SUCCESS'
export const CORE_DELETE_ROLE_FAILURE = 'CORE_DELETE_ROLE_FAILURE'

export const CORE_FILTER_ROLE_REQUEST = 'CORE_FILTER_ROLE_REQUEST'
export const CORE_FILTER_ROLE_SUCCESS = 'CORE_FILTER_ROLE_SUCCESS'
export const CORE_FILTER_ROLE_FAILURE = 'CORE_FILTER_ROLE_FAILURE'

export const CORE_LOAD_ROOMSFILTER_REQUEST = 'CORE_LOAD_ROOMSFILTER_REQUEST'
export const CORE_LOAD_ROOMSFILTER_SUCCESS = 'CORE_LOAD_ROOMSFILTER_SUCCESS'
export const CORE_LOAD_ROOMSFILTER_FAILURE = 'CORE_LOAD_ROOMSFILTER_FAILURE'




// WEBPACK FOOTER //
// ./src/types.js